import $ from 'jquery';

$(document).ready(() => {
    //your script
    console.log('page accueil ok')
})
